import { makeStyles } from '@material-ui/styles';
import { MDSImage } from '@marqvision/mds-v2';
import { BoundingBox, LogoDetectionData } from '../../../components';
import { Arrow } from './@components/Arrow';
import { Indicator } from './@components/Indicator';
import { useSlider } from './@hooks/useSlider';

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
  },
  imageList: {
    height: '100%',
    display: 'flex',
    alignItems: 'stretch',
  },
  imageItem: {
    position: 'relative',
    display: 'grid',
    placeItems: 'center',
  },
}));

type ImageItem = {
  url: string;
  detectionData?: LogoDetectionData[] | null;
};

type Props = {
  width: number;
  height: number;
  imageList: string[] | ImageItem[];
};

export const ImageSlider = (props: Props) => {
  const { width, height, imageList } = props;
  const classes = useStyles();

  const maxIndex = imageList.length - 1;
  const { translateX, transition, onMouseDown, arrowProps, indicatorProps } = useSlider({ width, maxIndex });

  return (
    <div className={classes.wrapper} style={{ width: `${width}px`, height: `${height}px` }} onMouseDown={onMouseDown}>
      {imageList.length ? (
        <div
          className={classes.imageList}
          style={{
            width: `${width * imageList.length}px`,
            transform: `translateX(${translateX}px)`,
            transition: `transform ${transition}ms`,
          }}
        >
          {imageList.map((item, index) => (
            <div key={`image-${index}`} className={classes.imageItem} style={{ width }}>
              <MDSImage
                removeBorderRadius
                fallbackStyle="tint"
                iconSize="large"
                width="100%"
                height="100%"
                objectFit="contain"
                src={typeof item === 'string' ? item : item.url}
              />

              {typeof item !== 'string' &&
                item.detectionData?.map((detectionData) => (
                  <BoundingBox
                    key={`${index}-${detectionData.bb_x1}-${detectionData.bb_y1}`}
                    detectionData={detectionData}
                  />
                ))}
            </div>
          ))}
        </div>
      ) : (
        <MDSImage isLoading removeBorderRadius fallbackStyle="tint" iconSize="large" width="100%" height="100%" />
      )}
      <Arrow {...arrowProps} />
      <Indicator {...indicatorProps} />
    </div>
  );
};

// 사용 예시
// const imageList: string[] = [
//   `https://picsum.photos/id/10/100/200`,
//   `https://picsum.photos/id/11/300/200`,
//   `https://picsum.photos/id/12/100/150`,
//   `https://picsum.photos/id/13/300`,
//   `https://picsum.photos/id/14/400/100`,
// ];
// <ImageSlider width={300} height={300} imageList={imageList} />
